import $ from 'jquery'

import { askUnreviewConfirmation } from '@app/shared/services/data-alteration-guard'

onDomLoad(function ($dom) {
  const accountEditForm = $dom[0].querySelector(
    "[data-behavior='account-edit-modal-form']"
  )

  if (!accountEditForm) return

  const accountDetailTemplateField = document.getElementById(
    'account_account_detail_template_id'
  )

  const originalAccountDetailTemplateValue = accountDetailTemplateField.value
  let accountDetailTemplateFieldChanged = false
  let userConfirmedUnReview = false

  accountDetailTemplateField.addEventListener('change', () => {
    accountDetailTemplateFieldChanged =
      originalAccountDetailTemplateValue !== accountDetailTemplateField.value
  })

  const confirmThenResubmit = async () => {
    const { confirmed } = await askUnreviewConfirmation()
    if (!confirmed) return

    userConfirmedUnReview = true
    // We use jQuery here because in Firefox this code runs before
    // the ajax:before event handler would finish and that creates all kind of bugs
    $(accountEditForm).submit()
  }

  $(accountEditForm).on('ajax:before', () => {
    if (!accountDetailTemplateFieldChanged) return
    if (userConfirmedUnReview) return

    // Returns false in the same tick to cancel this request. The resubmit
    // happens once the guard answers.
    void confirmThenResubmit()

    return false
  })
})
